import { gql } from "@apollo/client";

const GET_CONNECTIONS = gql`
  query getConnections($schacCode: String, $dashboardUserId: String)
    {getConnections(schacCode: $schacCode, dashboardUserId: $dashboardUserId) {
      userConnection
      heiConnection
      backendInstance
    }  
  }`
;

export default GET_CONNECTIONS;
